module.exports = __webpack_public_path__ + "img/intellect-right.4ceb37d9.png";